
<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'會員資料'"></app-nav-header>  
          <form class="page__content pageForm">
            <div class="row">
              <p-accordion (activeIndexChange)="activeIndexChange($event)"  [activeIndex]="activeIndex" [multiple]="false">
                <!-- 會員 -->
                <p-accordionTab header="會員" [selected]="true">
                  <p-scrollPanel [style]="{width: '100%'}">
                    <div class="grid p-fluid">
                        <div class="field mb-4">
                          <label for="MemberID" class="block">會員卡號 : <span style="font-weight: bold;">{{editModel.Member.MemberID}}</span></label>
                        </div>
                        <div class="field mb-4">
                          <label for="MemberNo" class="block">會員編號 : <span style="font-weight: bold;">{{editModel.Member.MemberNo}}</span></label>
                        </div>
                        <div class="field mb-4">
                          <ng-container  *ngIf="Step == 0;else editNameMode;">
                            <label for="Name" class="block">會員姓名 : <span style="font-weight: bold;">{{editModel.Member.Name}}</span></label>
                          </ng-container>
                          <ng-template #editNameMode>
                            <label for="Name" class="block notice">會員姓名</label>
                            <input id="Name" class="w-full" pInputText [(ngModel)]="editModel.Member.Name" [ngModelOptions]="{standalone: true}"/>
                          </ng-template>
                        </div>
                        <div class="field mb-4">
                          <ng-container *ngIf="Step == 0;else editGender;">
                            <label for="Gender" class="block">性別 : <span style="font-weight: bold;">{{editModel.Member.Gender == 0?"女":"男"}}</span></label>
                          </ng-container>
                          <ng-template #editGender>
                            <label for="Gender" class="block">性別</label>
                            <p-dropdown [options]="GenderList" [(ngModel)]="editModel.Member.Gender" placeholder="請選擇" optionLabel="label"  optionValue="value" [ngModelOptions]="{standalone: true}"></p-dropdown>
                          </ng-template>
                        </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editPhone;">
                              <label for="Telephone" class="block">手機電話 : <span style="font-weight: bold;">{{editModel.Member.Telephone}}</span></label>
                            </ng-container>
                            <ng-template #editPhone>
                              <label for="Telephone" class="block notice">手機電話</label>
                              <input id="Telephone" class="w-full" pInputText [(ngModel)]="editModel.Member.Telephone" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editPhone1;">
                              <label for="Telephone1" class="block">備用電話 : <span style="font-weight: bold;">{{editModel.Member.Telephone1}}</span></label>
                            </ng-container>
                            <ng-template #editPhone1>
                              <label for="Telephone" class="block">備用電話</label>
                              <input id="Telephone1" class="w-full" pInputText [(ngModel)]="editModel.Member.Telephone1" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editEmail;">
                              <label for="Email" class="block">Email信箱 : <span style="font-weight: bold;">{{editModel.Member.Email}}</span></label>
                            </ng-container>
                            <ng-template #editEmail>
                              <label for="Email" class="block">Email信箱</label>
                              <input id="Email" class="w-full" pInputText [(ngModel)]="editModel.Member.Email" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editBirthday;">
                              <label for="Birthday" class="block">生日 : <span style="font-weight: bold;">{{editModel.Member.Birthday}}</span></label>
                            </ng-container>
                            <ng-template #editBirthday>
                              <label for="Birthday" class="block">生日</label>
                              <p-calendar [(ngModel)]="editModel.Member.Birthday" [touchUI]="true" [readonlyInput]="true" inputId="touchui" name="Birthday" dataType="string" dateFormat="yy-mm-dd"></p-calendar>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editUni;">
                              <label for="UnionID" class="block">身分證字號 : <span style="font-weight: bold;">{{editModel.Member.UnionID}}</span></label>
                            </ng-container>
                            <ng-template #editUni>
                              <label for="Birthday" class="block">身分證字號</label>
                              <input id="UnionID" class="w-full" pInputText [(ngModel)]="editModel.Member.UnionID" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div *ngIf="editModel.Member.MemberLevel != null || editModel.Member.MemberLevel == ''" class="field">
                            <label for="Level" class="block">會員等級 :  <span style="font-weight: bold;">{{editModel.Member.MemberLevel}}</span></label>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editAdd;">
                              <label for="Add" class="block">地址 : <span style="font-weight: bold;">{{!!Address==false?"":Address}}{{editModel.Member.Add3}}</span></label>
                            </ng-container>
                            <ng-template #editAdd>
                              <label for="Add1" class="block">地址</label>
                              <p-dropdown *ngIf="CityList != null" [options]="CityList" [(ngModel)]="editModel.Member.Add1" placeholder="請選擇" appendTo="body" [ngModelOptions]="{standalone: true}" (ngModelChange)="SelectCity()"></p-dropdown>

                              <p-dropdown *ngIf="ZipList != null" [options]="ZipList" [(ngModel)]="editModel.Member.Add2" placeholder="請選擇" appendTo="body" [ngModelOptions]="{standalone: true}"></p-dropdown>
                              
                            <input id="Add3" pInputText [(ngModel)]="editModel.Member.Add3" [ngModelOptions]="{standalone: true}"/> 
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editContact;">
                              <label for="Contact" class="block">緊急聯絡人 : <span style="font-weight: bold;">{{editModel.Member.Contact}}</span></label>
                            </ng-container>
                            <ng-template #editContact>
                              <label for="Contact" class="block">緊急聯絡人</label>
                              <input id="Contact" class="w-full" pInputText [(ngModel)]="editModel.Member.Contact" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editRelationship;">
                              <label for="Relationship" class="block">與飼主關係 : <span style="font-weight: bold;">{{editModel.Member.Relationship}}</span></label>
                            </ng-container>
                            <ng-template #editRelationship>
                              <label for="Relationship" class="block">與飼主關係</label>
                              <input id="Relationship" class="w-full" pInputText [(ngModel)]="editModel.Member.Relationship" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editContactTel;">
                              <label for="ContactTel" class="block">聯絡電話 : <span style="font-weight: bold;">{{editModel.Member.ContactTel}}</span></label>
                            </ng-container>
                            <ng-template #editContactTel>
                              <label for="ContactTel" class="block">聯絡電話</label>
                              <input id="ContactTel" class="w-full" pInputText [(ngModel)]="editModel.Member.ContactTel" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editHospital;">
                              <label for="Hospital" class="block">動物醫院名稱 : <span style="font-weight: bold;">{{editModel.Member.Hospital}}</span></label>
                            </ng-container>
                            <ng-template #editHospital>
                              <label for="Hospital" class="block">動物醫院名稱</label>
                              <input id="Hospital" class="w-full" pInputText [(ngModel)]="editModel.Member.Hospital" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editHospitalTel;">
                              <label for="HospitalTel" class="block">動物醫院電話 : <span style="font-weight: bold;">{{editModel.Member.HospitalTel}}</span></label>
                            </ng-container>
                            <ng-template #editHospitalTel>
                              <label for="HospitalTel" class="block">動物醫院電話</label>
                              <input id="HospitalTel" class="w-full" pInputText [(ngModel)]="editModel.Member.HospitalTel" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                          <div class="field mb-4">
                            <ng-container *ngIf="Step == 0;else editHA;">
                              <label for="HospitalAddress" class="block">動物醫院地址 : <span style="font-weight: bold;">{{editModel.Member.HospitalAddress}}</span> </label>
                            </ng-container>
                            <ng-template #editHA>
                              <label for="HospitalAddress" class="block">動物醫院地址</label>
                              <input id="HospitalAddress" class="w-full" pInputText [(ngModel)]="editModel.Member.HospitalAddress" [ngModelOptions]="{standalone: true}"/>
                            </ng-template>
                          </div>
                    </div>
                    
                  </p-scrollPanel>
                </p-accordionTab>
                <!-- 寵物 -->
                <p-accordionTab *ngFor="let pet of editModel.Pets" header="寵物-{{pet.PetName}}">
                  <ng-container *ngIf="Step == 0;else editPic;">
                    <p-galleria [value]="pet.gallyBox" [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '640px'}" [numVisible]="5"
                    [circular]="true" [showItemNavigators]="true" [showThumbnails]="false">
                        <ng-template pTemplate="item" let-item>
                            <img [src]="item.source" style="width: 200px; display: block;" />
                        </ng-template>
                        <ng-template pTemplate="thumbnail" let-item>
                            <div class="grid grid-nogutter justify-content-center">
                                <img [src]="item.thumbnailImageSrc" style="display: block;" />
                            </div>
                        </ng-template>
                    </p-galleria>
                    <p-scrollPanel [style]="{width: '250px', 'height': '300px'}">
                      <div class="grid p-fluid">
                          <div class="field mb-4">
                            <label for="PetName" class="block">寵物名稱 : <span style="font-weight: bold;">{{pet.PetName}}</span></label>
                          </div>
                          <div class="field mb-4 mt-1">
                            <label for="Birthday" class="block">生日 : <span style="font-weight: bold;">{{pet.Birthday}}</span></label>
                          </div>
                          <div class="field mb-4 mt-1">
                            <label for="Gender" class="block">性別 : <span style="font-weight: bold;">{{pet.Gender == '0'?"母":"公"}}</span></label>
                          </div>
                            <div class="field mb-4 mt-1">
                              <label for="Color" class="block">毛色 : <span style="font-weight: bold;">{{pet.Color}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="Size" class="block">體型 : <span style="font-weight: bold;">{{pet.SizeName}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="VarietyTypeName" class="block">寵物類型 : <span style="font-weight: bold;">{{pet.VarietyTypeName}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="VarietyName" class="block">品種 : <span style="font-weight: bold;">{{pet.VarietyName}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="SterilizationFlag" class="block">結紮 : <span style="font-weight: bold;">{{pet.SterilizationFlag == "Y"?"已結紮":"未結紮"}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="CarryFlag" class="block">是否接送 : <span style="font-weight: bold;">{{pet.CarryFlag == "Y"?"是":"否"}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="hasWafer" class="block">是否晶片 : <span style="font-weight: bold;">{{pet.hasWafer == "Y"?"是":"否"}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="Medical" class="block">寵物病史 : <span style="font-weight: bold;">{{ShowPetMedicalHistory(pet)}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="CatLitter" class="block">貓砂 : <span style="font-weight: bold;">{{ShowPetCatLitter(pet)}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="Vaccine" class="block">疫苗 : <span style="font-weight: bold;">{{ShowPetVaccine(pet)}}</span></label>
                            </div>
                            <div class="field mb-4 mt-1">
                              <label for="vaccineDate" class="block">疫苗日期 : <span style="font-weight: bold;">{{pet.vaccineDate}}</span></label>
                            </div>
                      </div>
                      
                    </p-scrollPanel>
                  </ng-container>
                  <ng-template #editPic>
                    <p-scrollPanel [style]="{width: '100%'}">
                      <div class="grid p-fluid">
                          <div class="field mb-4">
                            <label for="PetName" class="block notice">寵物名稱</label>
                              <input id="PetName" class="w-full" pInputText [(ngModel)]="pet.PetName" [ngModelOptions]="{standalone: true}" />
                          </div>
                          <div class="field mb-4">
                              <label for="Size" class="block notice">寵物類型</label>
                                <p-dropdown *ngIf="VarietyTypeList != null" [options]="VarietyTypeList" [(ngModel)]="pet.VarietyType" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}" (ngModelChange)="SelectVarietyType(pet)"></p-dropdown>
                          </div>
                          <div class="field mb-4">
                              <label for="Size" class="block notice">品種</label>
                                <p-dropdown *ngIf="pet.VarietyList != null" [options]="pet.VarietyList" [(ngModel)]="pet.Variety" placeholder="請選擇" optionLabel="label" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                          </div>
                          <div class="field mb-4">
                              <label for="Size" class="block">體型</label>
                              <p-dropdown *ngIf="SizesList != null" [options]="SizesList" [(ngModel)]="pet.Size" placeholder="請選擇" optionLabel="label"  optionValue="value" [showClear]="true" [ngModelOptions]="{standalone: true}" appendTo="body" [filter]="true"  filterBy="label"></p-dropdown>
                          </div>
                          <div class="field mb-4">
                            <label for="Birthday" class="block">生日</label>
                              <p-calendar [(ngModel)]="pet.Birthday" [touchUI]="true" [readonlyInput]="true" inputId="touchui" name="Birthday" dataType="string" dateFormat="yy-mm-dd"></p-calendar>
                          </div>
                          <div class="field mb-4">
                            <label for="Gender" class="block">性別</label>
                              <p-dropdown [options]="GenderList" [(ngModel)]="pet.Gender" placeholder="請選擇" optionLabel="label"  optionValue="value" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                          </div>
                          <div class="field mb-4">
                              <label for="Color" class="block">毛色</label>
                              <input id="Color" class="w-full" pInputText [(ngModel)]="pet.Color" [ngModelOptions]="{standalone: true}" />
                          </div>
                          <div class="flex flex-column gap-2 mb-3">
                            <label class="block mb-2">結紮</label>
                            <p-toggleButton styleClass="w-full"
                              onLabel="已結紮"
                              offLabel="未結紮"
                              [ngModel]="pet.SterilizationFlag === 'Y'"
                              (ngModelChange)="pet.SterilizationFlag = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                            </p-toggleButton>
                          </div>
                          <div class="flex flex-column gap-2 mb-3">
                            <label class="block mb-2">是否接送</label>
                            <p-toggleButton styleClass="w-full"
                              onLabel="要接送"
                              offLabel="不接送"
                              [ngModel]="pet.CarryFlag === 'Y'"
                              (ngModelChange)="pet.CarryFlag = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                            </p-toggleButton>
                          </div>
                          <div class="flex flex-column gap-2 mb-3">
                            <label class="block mb-2">是否晶片</label>
                            <p-toggleButton styleClass="w-full"
                              onLabel="有晶片"
                              offLabel="沒晶片"
                              [ngModel]="pet.hasWafer === 'Y'"
                              (ngModelChange)="pet.hasWafer = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                            </p-toggleButton>
                          </div>
                          <div class="card p-3 mb-3">
                              <label class="font-medium mb-3 block">寵物病史</label>
                              <div class="flex flex-column gap-3">
                                  <div *ngFor="let item of pet.PetMedicalHistory.MedicalHistoryItems; let i = index"
                                      class="flex align-items-center">
                                    <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                                    </p-checkbox>
                                    <label class="ml-2 text-base">
                                      {{ MedicalHistoryOption[i].Name }}
                                    </label>
                                  </div>
                                  <div class="mt-3">
                                    <label class="block font-medium mb-1">其他</label>
                                    <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="pet.PetMedicalHistory.MedicalHistoryItemsNote"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                    </textarea>
                                  </div>
                                </div>
                          </div>
                          <div class="card p-3 mb-3">
                              <label class="font-medium mb-3 block">貓砂</label>
                              <div class="flex flex-column gap-3">
                                  <div *ngFor="let item of pet.CatLitterList.Items; let i = index"
                                      class="flex align-items-center">
                                    <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                                    </p-checkbox>
                                    <label class="ml-2 text-base">
                                      {{ CatLitterOption[i].Name }}
                                    </label>
                                  </div>
                                  <div class="mt-3">
                                    <label class="block font-medium mb-1">其他</label>
                                    <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="pet.CatLitterList.Note"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                    </textarea>
                                  </div>
                                </div>
                          </div>
                          <div class="card p-3 mb-3">
                              <label class="font-medium mb-3 block">疫苗</label>
                              <div class="flex flex-column gap-3">
                                  <div *ngFor="let item of pet.VaccineList.Items; let i = index"
                                      class="flex align-items-center">
                                    <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                                    </p-checkbox>
                                    <label class="ml-2 text-base">
                                      {{ VaccineOption[i].Name }}
                                    </label>
                                  </div>
                                  <div class="mt-3">
                                    <label class="block font-medium mb-1">其他</label>
                                    <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="pet.VaccineList.Note"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                    </textarea>
                                  </div>
                                </div>
                          </div>
                          <div class="field mb-4">
                              <label for="Color" class="block">疫苗日期</label>
                              <p-calendar [(ngModel)]="pet.vaccineDate" [touchUI]="true" [readonlyInput]="true" inputId="touchui" name="vaccineDate" dataType="string" dateFormat="yy-mm-dd"></p-calendar>
                          </div>
                      </div>
                      
                    </p-scrollPanel>
                    <p-fileUpload #PetPhoto (onSelect)="onPhotoUpload($event,pet, PetPhoto)" mode="advanced"
                    [multiple]="true" accept="image/*" [maxFileSize]="200000000" [auto]="false" [showUploadButton]="false"[showCancelButton]="true"></p-fileUpload>
                    <div class="ui-g-12 d-flex">
                      <!--有舊圖 -->
                      <div class="uploadPicture d-flex" *ngIf="!!pet.OldPhotos && pet.OldPhotos.length>0" style="max-width: 1000px;overflow: visible;">
                        <div *ngFor="let workPath of pet.OldPhotos" style="display: grid;">
                          <img src="{{baseUrl}}/{{workPath}}" width="100px">
                          <a (click)="DeleteOldPhoto(workPath,pet)">
                              <i class="pi pi-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12 d-flex" *ngIf="pet.NewPhotoUrls != undefined && pet.NewPhotoUrls.length>0" style="max-width: 1000px;overflow: visible;">
                      <div *ngFor="let url of pet.NewPhotoUrls" style="display: grid;">
                        <img src="{{url}}" width="100px">
                        <a (click)="DeleteNewPhoto(url,pet)">
                            <i class="pi pi-times"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-12 mt-2 mb-2">
                      <div class="pageForm__item col-sm-8 mx-auto px-0" style="color:blue;font-weight: 700;">
                        <p>圖檔大小:{{ picSize }} KB</p>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>
                <div class="col-12 col-md-6 p-1 text-center">
                  <ng-container *ngIf="Step == 0;else editMode;">
                    <div class="col-12 col-md-6 p-1">
                      <app-button appClass="pageForm__btn d-block text-center text-white w-100" (appClick)="ChangeView(1)" appLabel="修改" [loading]="isLoading"></app-button>
                    </div>
                  </ng-container>
                  <ng-template #editMode>
                    <div class="col-12 col-md-6 p-1">
                      <app-button appClass="pageForm__btn d-block text-center text-white w-100" (appClick)="ChangeView(0)" appLabel="儲存" [loading]="isLoading" [disabled]="!UpdateRequired()"></app-button>
                    </div>
                    <div class="col-12 col-md-6 p-1">
                      <app-button appClass="pageForm__btn d-block text-center text-white w-100" (appClick)="ChangeView(2)" appLabel="放棄修改" [loading]="isLoading"></app-button>
                    </div>
                  </ng-template>
                  <div class="col-12 col-md-6 p-1" style="text-align: center;">
                    <p-button label="新增寵物" styleClass="p-button-link" (onClick)="NewPet()"></p-button>
                  </div>
                </div>
            </p-accordion>
            </div>
          </form>
          <!-- 新增畫面 -->
          <p-sidebar [(visible)]="showDs" [fullScreen]="true" [baseZIndex]="10000">
            <p-scrollPanel [style]="{width: '100%', height: '800px'}">
              <div class="grid p-fluid">
                  <div class="field mb-4">
                    <label class="block notice">寵物名稱</label>
                    <input class="w-full" pInputText [(ngModel)]="newEditModel.PetName" [ngModelOptions]="{standalone: true}" />
                  </div>
                  <div class="field mb-4 d-block">
                    <p class="block notice">寵物類型</p>
                    <p-dropdown *ngIf="VarietyTypeList != null" [options]="VarietyTypeList" [(ngModel)]="newEditModel.VarietyType" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}" [filter]="true" (ngModelChange)="SelectVarietyType(newEditModel)"></p-dropdown>
                  </div>
                  <div class="field mb-4 d-block">
                    <p class="block notice">品種</p>
                    <p-dropdown *ngIf="newEditModel.VarietyList != null" [options]="newEditModel.VarietyList" [(ngModel)]="newEditModel.Variety" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}" optionLabel="label" [filter]="true" filterBy="label"></p-dropdown>
                  </div>
                  <div class="field mb-4 d-block">
                     <p class="block">體型</p>
                     <p-dropdown *ngIf="SizesList != null" [options]="SizesList" [(ngModel)]="newEditModel.Size" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}" [filter]="true"></p-dropdown>
                  </div>
                  <div class="field mb-4">
                     <label for="Birthday" class="block">生日</label>
                     <p-calendar [(ngModel)]="newEditModel.Birthday" name="Birthday" dataType="string" dateFormat="yy-mm-dd" appendTo="body"></p-calendar>
                  </div>
                  <div class="field mb-4">
                     <label for="Gender" class="block">性別</label>
                     <p-dropdown [options]="GenderList" [(ngModel)]="newEditModel.Gender" placeholder="請選擇" appendTo="body" [showClear]="true" [ngModelOptions]="{standalone: true}"></p-dropdown>
                  </div>
                  <div class="field mb-4">
                     <label for="Color" class="block">毛色</label>
                     <input id="Color" class="w-full" pInputText [(ngModel)]="newEditModel.Color" [ngModelOptions]="{standalone: true}" />
                  </div>
                  <div class="flex flex-column gap-2 mb-3">
                     <label class="block mb-2">結紮</label>
                     <p-toggleButton styleClass="w-full"
                              onLabel="已結紮"
                              offLabel="未結紮"
                              [ngModel]="newEditModel.SterilizationFlag === 'Y'"
                              (ngModelChange)="newEditModel.SterilizationFlag = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                      </p-toggleButton>
                  </div>
                  <div class="flex flex-column gap-2 mb-3">
                       <label class="block mb-2">是否接送</label>
                       <p-toggleButton styleClass="w-full"
                              onLabel="要接送"
                              offLabel="不接送"
                              [ngModel]="newEditModel.CarryFlag === 'Y'"
                              (ngModelChange)="newEditModel.CarryFlag = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                       </p-toggleButton>
                  </div>
                  <div class="flex flex-column gap-2 mb-3">
                       <label class="block mb-2">是否晶片</label>
                       <p-toggleButton styleClass="w-full"
                              onLabel="有晶片"
                              offLabel="沒晶片"
                              [ngModel]="newEditModel.hasWafer === 'Y'"
                              (ngModelChange)="newEditModel.hasWafer = $event ? 'Y' : 'N'"
                              [ngModelOptions]="{standalone: true}">
                       </p-toggleButton>
                  </div>
                  <div class="card p-3 mb-3" *ngIf="!!newEditModel.PetMedicalHistory">
                       <label class="font-medium mb-3 block">寵物病史</label>
                       <div class="flex flex-column gap-3">
                             <div *ngFor="let item of newEditModel.PetMedicalHistory.MedicalHistoryItems"
                                      class="flex align-items-center">
                                <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                                </p-checkbox>
                                <label class="ml-2 text-base">
                                      {{ item.Name }}
                                </label>
                             </div>
                             <div class="mt-3">
                                <label class="block font-medium mb-1">其他</label>
                                <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="newEditModel.PetMedicalHistory.MedicalHistoryItemsNote"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                </textarea>
                              </div>
                          </div>
                  </div>
                  <div class="card p-3 mb-3" *ngIf="!!newEditModel.CatLitterList">
                       <label class="font-medium mb-3 block">貓砂</label>
                       <div class="flex flex-column gap-3">
                              <div *ngFor="let item of newEditModel.CatLitterList.Items; let i = index"
                                      class="flex align-items-center">
                                <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                                </p-checkbox>
                                <label class="ml-2 text-base">
                                      {{ item.Name }}
                                </label>
                              </div>
                              <div class="mt-3">
                                 <label class="block font-medium mb-1">其他</label>
                                 <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="newEditModel.CatLitterList.Note"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                  </textarea>
                              </div>
                          </div>
                  </div>
                  <div class="card p-3 mb-3" *ngIf="!!newEditModel.VaccineList">
                       <label class="font-medium mb-3 block">疫苗</label>
                       <div class="flex flex-column gap-3">
                             <div *ngFor="let item of newEditModel.VaccineList.Items; let i = index"
                                      class="flex align-items-center">
                              <p-checkbox
                                      [binary]="true"
                                      [(ngModel)]="item.Selected"
                                      [ngModelOptions]="{standalone: true}">
                              </p-checkbox>
                              <label class="ml-2 text-base">
                                      {{ item.Name }}
                              </label>
                            </div>
                            <div class="mt-3">
                                <label class="block font-medium mb-1">其他</label>
                                <textarea rows="3"
                                              pInputTextarea
                                              [(ngModel)]="newEditModel.VaccineList.Note"
                                              maxlength="50"
                                              [ngModelOptions]="{standalone: true}">
                                </textarea>
                            </div>
                          </div>
                 </div>
                 <div class="field mb-4">
                      <label for="Color" class="block">疫苗日期</label>
                      <p-calendar [(ngModel)]="newEditModel.vaccineDate" [touchUI]="true" [readonlyInput]="true" inputId="touchui" name="vaccineDate" dataType="string" dateFormat="yy-mm-dd"></p-calendar>
                  </div>
                  <p-fileUpload #PetPhoto (onSelect)="onPhotoUpload($event,newEditModel, PetPhoto)" mode="advanced"
                    [multiple]="true" accept="image/*" [maxFileSize]="20000000" [auto]="false" [showUploadButton]="false"[showCancelButton]="true"></p-fileUpload>
                      <div class="ui-g-12 d-flex">
                        <div class="uploadPicture d-flex" *ngIf="!!newEditModel.OldPhotos && newEditModel.OldPhotos.length>0" style="max-width: 80%;overflow: visible;">
                          <div *ngFor="let workPath of newEditModel.OldPhotos" style="display: grid;">
                            <img src="{{baseUrl}}/{{workPath}}" width="100px">
                            <a (click)="DeleteOldPhoto(workPath,newEditModel)">
                                <i class="pi pi-times"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12 d-flex" *ngIf="!!newEditModel.NewPhotoUrls && newEditModel.NewPhotoUrls.length>0" style="max-width: 80%;overflow: visible;">
                        <div *ngFor="let url of newEditModel.NewPhotoUrls" style="display: grid;">
                          <img src="{{url}}" width="100px">
                          <a (click)="DeleteNewPhoto(url,newEditModel)">
                              <i class="pi pi-times"></i>
                          </a>
                        </div>
                      </div>
                      <div class="col-12 mt-2 mb-2">
                        <div class="pageForm__item col-sm-8 mx-auto px-0" style="color:blue;font-weight: 700;">
                          <p>圖檔大小:{{ picSize }} KB</p>
                        </div>
                      </div>
                  <div class="reserve__container row mx-auto">
                     <div class="col-12 col-md-6 p-1" style="text-align: center;">
                        <app-button appClass="pageForm__btn d-block text-center text-white w-100" (appClick)="SavePet()" appLabel="儲存" [loading]="isLoading" [disabled]="!EditRequired()"></app-button>
                     </div>
                  </div>
              </div>
            </p-scrollPanel>
          </p-sidebar>
  </ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>